import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71f5dce0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form_wrap" }
const _hoisted_2 = { class: "form_input_content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_input_content_title" }, "绑定直播间：", -1))
const _hoisted_4 = { class: "form_input_content_content" }
const _hoisted_5 = { class: "form_input_content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_input_content_title" }, "活动名称：", -1))
const _hoisted_7 = { class: "form_input_content_content" }
const _hoisted_8 = { class: "ficc" }
const _hoisted_9 = { class: "swfi_c_txt" }
const _hoisted_10 = { class: "form_input_content mbottom" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_input_content_title" }, "活动规则：", -1))
const _hoisted_12 = { class: "form_input_content_content" }
const _hoisted_13 = { class: "ficc" }
const _hoisted_14 = { class: "swfi_area_num" }
const _hoisted_15 = { class: "form_input_content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_input_content_title" }, "弹出时长：", -1))
const _hoisted_17 = { class: "form_input_content_content num" }
const _hoisted_18 = { class: "ficc" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "秒", -1))
const _hoisted_20 = { class: "form_input_content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_input_content_title" }, "集齐", -1))
const _hoisted_22 = { class: "form_input_content_content num" }
const _hoisted_23 = { class: "ficc" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "张不同福卡可参与抽奖", -1))
const _hoisted_25 = { class: "form_input_content" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_input_content_title" }, "中奖人数：", -1))
const _hoisted_27 = { class: "form_input_content_content num" }
const _hoisted_28 = { class: "ficc" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "个", -1))
const _hoisted_30 = { class: "form_input_content mbottom" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_input_content_title" }, "集卡中奖开关：", -1))
const _hoisted_32 = { class: "form_input_content_content" }
const _hoisted_33 = { class: "form_input_content mbottom" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_input_content_title" }, "文案编辑", -1))
const _hoisted_35 = { class: "form_input_content_content" }
const _hoisted_36 = { class: "form_input_content" }
const _hoisted_37 = { class: "form_input_content_title" }
const _hoisted_38 = { class: "form_input_content" }
const _hoisted_39 = { class: "form_input_content_content" }
const _hoisted_40 = { class: "form_input_content_content" }
const _hoisted_41 = { class: "form_input_content submit" }
const _hoisted_42 = { class: "form_input_content_title" }
const _hoisted_43 = { class: "form_input_content" }
const _hoisted_44 = { class: "form_input_content_content" }
const _hoisted_45 = { class: "form_input_content_content" }
const _hoisted_46 = { class: "form_input_content" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_input_content_title" }, null, -1))
const _hoisted_48 = { class: "form_input_content_content" }

import { computed, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { FiveLuckForm } from '@/types/application/FiveLuckyGame';
import { Input, InputNumber, message, Form } from 'ant-design-vue';
import fiveLuckyApi from '@/api/application/fiveLuckyGame';
import { useDebounce } from '@/hooks/useDebounce';


export default /*#__PURE__*/_defineComponent({
  __name: 'add',
  setup(__props) {

const aTextarea = Input.TextArea;
const aInputNumber = InputNumber;
const route = useRoute();
const router = useRouter();
const useForm = Form.useForm;
const aFormItem = Form.Item;

const formData = ref<FiveLuckForm>({
  title: '', //福卡名称
  intro: '', //福卡简介
  studio_id: '', //直播间ID
  status: 0, // 开关状态
  open: 0, //开奖状态
  max: 0, //集齐此数量福卡的用户可参与抽奖
  duration: 0, //福卡弹出时长
  num: 1, //中奖名额
  zh_win_msg: '恭喜您，中奖啦!', // 中文中奖提示文案
  en_win_msg: "Congratulations, you've won the prize!", // 英文中奖提示文案
  zh_not_win_msg: '很遗憾，您未中奖', // 中文未中奖提示文案
  en_not_win_msg: "Unfortunately, you didn't win the prize", //英文未中奖提示文案
  card_win_switch: 0, //集卡中奖开关0.关；1.开
});

const rulesRef = reactive({
  studio_id: [
    {
      required: true,
      message: '请输入直播间ID',
    },
  ],
  title: [
    {
      required: true,
      message: '请输入活动名称',
    },
  ],
  duration: [
    {
      required: true,
      type: 'number',
      message: '请输入弹出时长',
    },
  ],
  max: [
    {
      required: true,
      type: 'number',
      message: '请完善中奖条件',
    },
  ],
  num: [
    {
      required: true,
      type: 'number',
      message: '请输入中奖人数',
    },
  ],
  zh_win_msg: [
    {
      required: true,
      message: '请输入中文中奖提示',
    },
  ],
  en_win_msg: [
    {
      required: true,
      message: '请输入英文中奖提示',
    },
  ],
  zh_not_win_msg: [
    {
      required: true,
      message: '请输入中文未中奖提示',
    },
  ],
  en_not_win_msg: [
    {
      required: true,
      message: '请输入英文未中奖提示',
    },
  ],
});
const { validate, validateInfos } = useForm(formData, rulesRef);

const getInfo = () => {
  if (route.query?.id == null) return;
  fiveLuckyApi
    .getfiveBlessingView({
      params: {
        id: route.query?.id,
      },
    })
    .then((res) => {
      formData.value = res.data.data;
      formData.value.zh_win_msg = res.data.data.zh_win_msg || '恭喜您，中奖啦!';
      formData.value.en_win_msg = res.data.data.en_win_msg || "Congratulations, you've won the prize!";
      formData.value.zh_not_win_msg = res.data.data.zh_not_win_msg || '很遗憾，您未中奖';
      formData.value.en_not_win_msg = res.data.data.en_not_win_msg || "Unfortunately, you didn't win the prize";
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

getInfo();

const restForm = () => {
  router.push({ name: 'FiveLuckyGame' });
};

const apifunc = computed(() => (formData.value?.id ? 'editfiveBlessing' : 'addfiveBlessing'));
const fetching = ref(false);
const submit = useDebounce(() => {
  validate()
    .then(() => {
      fetching.value = true;
      fiveLuckyApi[apifunc.value](formData.value)
        .then(() => {
          message.success('操作成功！');
          router.push({ name: 'FiveLuckyGame' });
        })
        .catch((err) => {
          message.error(err.data.error);
        })
        .finally(() => {
          fetching.value = false;
        });
    })
    .catch((err) => {
      console.log('error', err);
    });
});

const lingo = reactive({ winMsg: true, notWinMsg: true });

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(aFormItem), _normalizeProps(_guardReactiveProps(_unref(validateInfos).studio_id)), {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formData.value.studio_id,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.studio_id) = $event)),
              size: "large",
              placeholder: "请输入直播间ID"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 16)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(aFormItem), _normalizeProps(_guardReactiveProps(_unref(validateInfos).title)), {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formData.value.title,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.title) = $event)),
                maxlength: 80,
                class: "swfi_c_input",
                size: "large",
                placeholder: "请输入活动名称"
              }, {
                suffix: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(formData.value.title.length) + "/80", 1)
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 16)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_unref(aTextarea), {
            value: formData.value.intro,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.intro) = $event)),
            maxLength: "80",
            class: "swfi_c_textarea",
            size: "large",
            placeholder: "例如：直播过程中会不定时推送福卡，观众集齐五福后在线上兑换奖品"
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_14, _toDisplayString(formData.value.intro.length) + "/80", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_unref(aFormItem), _normalizeProps(_guardReactiveProps(_unref(validateInfos).duration)), {
            default: _withCtx(() => [
              _createVNode(_unref(aInputNumber), {
                value: formData.value.duration,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.duration) = $event)),
                class: "swfi_c_input",
                min: 3
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16)
        ]),
        _hoisted_19
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_unref(aFormItem), _normalizeProps(_guardReactiveProps(_unref(validateInfos).max)), {
            default: _withCtx(() => [
              _createVNode(_unref(aInputNumber), {
                value: formData.value.max,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.max) = $event)),
                class: "swfi_c_input",
                min: 1
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16)
        ]),
        _hoisted_24
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_unref(aFormItem), _normalizeProps(_guardReactiveProps(_unref(validateInfos).num)), {
            default: _withCtx(() => [
              _createVNode(_unref(aInputNumber), {
                value: formData.value.num,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.num) = $event)),
                class: "swfi_c_input",
                min: 1
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16)
        ]),
        _hoisted_29
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_a_switch, {
          checked: formData.value.card_win_switch,
          "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.card_win_switch) = $event)),
          "checked-value": 1,
          "un-checked-value": 0
        }, null, 8, ["checked"])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", {
          class: "form_input_content_btn",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (lingo.winMsg = !lingo.winMsg))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass({ txt: lingo.winMsg })
          }, "中", 2),
          _createTextVNode("   /    "),
          _createElementVNode("span", {
            class: _normalizeClass({ txt: !lingo.winMsg })
          }, "EN", 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, _toDisplayString(lingo.winMsg ? '中奖提示：' : '中奖提示：'), 1),
      _createElementVNode("div", _hoisted_38, [
        _withDirectives(_createElementVNode("div", _hoisted_39, [
          _createVNode(_unref(aFormItem), _normalizeProps(_guardReactiveProps(_unref(validateInfos).zh_win_msg)), {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formData.value.zh_win_msg,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.zh_win_msg) = $event)),
                size: "large",
                placeholder: "请输入中奖提示"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16)
        ], 512), [
          [_vShow, lingo.winMsg]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_40, [
          _createVNode(_unref(aFormItem), _normalizeProps(_guardReactiveProps(_unref(validateInfos).en_win_msg)), {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formData.value.en_win_msg,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.en_win_msg) = $event)),
                size: "large",
                placeholder: "Please enter the text of the winning prompt"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16)
        ], 512), [
          [_vShow, !lingo.winMsg]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, _toDisplayString(lingo.winMsg ? '未中奖提示：' : '未中奖提示：'), 1),
      _createElementVNode("div", _hoisted_43, [
        _withDirectives(_createElementVNode("div", _hoisted_44, [
          _createVNode(_unref(aFormItem), _normalizeProps(_guardReactiveProps(_unref(validateInfos).zh_not_win_msg)), {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formData.value.zh_not_win_msg,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.zh_not_win_msg) = $event)),
                size: "large",
                placeholder: "请输入未中奖提示"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16)
        ], 512), [
          [_vShow, lingo.winMsg]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_45, [
          _createVNode(_unref(aFormItem), _normalizeProps(_guardReactiveProps(_unref(validateInfos).en_not_win_msg)), {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formData.value.en_not_win_msg,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.en_not_win_msg) = $event)),
                size: "large",
                placeholder: "Prompt copy of failing to win the prize in English"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16)
        ], 512), [
          [_vShow, !lingo.winMsg]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _hoisted_47,
      _createElementVNode("div", _hoisted_48, [
        _createVNode(_component_a_button, {
          class: "sub_cancel",
          onClick: restForm
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取消 ")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          loading: fetching.value,
          onClick: _unref(submit)
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ])
  ]))
}
}

})